import React from 'react';
import { withTranslation } from 'language/i18n';
import PropTypes from 'prop-types';

import Layout from 'components/partials/Layout';
import Breadcrumb from 'components/Breadcrumb';
import FooterContactUs from './components/footer/FooterContactUs';
import SellYourMachineIn30Days from './components/SellYourMachineIn30Days';

const ShippingAndDelivery = ({ t }) => {
  const breadcrumbs = [
    {
      label: t('homepage'),
      url: '/',
    },
    {
      label: t('shippingAndDelivery'),
      url: '/content/shipping-and-delivery',
    },
  ];

  return (
    <main className="has-header">
      <div className="container">
        <div className="row mt-4 mb-4 mt-lg-3 mb-lg-3">
          <div className="col">
            <Breadcrumb links={breadcrumbs} />
          </div>
        </div>
        <div className="row">
          <div className="col-md-10 col-lg-11 mt-3 mt-md-0">
            <div className="row mb-20">
              <div className="col">
                <h1 className="h1">Nakliye ve Teslimat</h1>
              </div>
            </div>
            <div className="row mb-20">
              <div className="col-15">
                <p>
                  Satılan makinaların nakliye sorumluluğu
                  {' '}
                  <b>Alıcıya</b>
                  {' '}
                  aittir.
                  Alıcı, gerekli düzenlemeleri yaparak makinayı bulunduğu lokasyondan teslim alacaktır.
                </p>
                <p>
                  Satın aldığı makinanın tüm ödemesini yapan alıcı, 8 gün içerisinde makinayı bulunduğu lokasyondan almak durumundadır.
                  8 gün alınmayan makinanın teslim alınmadığı her gün için gecikme ücreti tahsil edilecektir.
                  60 günden fazla nakliyesi yapılmayan makinaların satın alma hakkı iptal olacaktır.
                </p>
                <p>
                  Satıcı ve iyiMakina.com’un nakliye ile ilgili bir sorumluluğu yoktur.
                  Satıcının bir konteynere herhangi bir ataşman vb. makina teçhizatı yüklemek zorunda değildir.
                  Satın alınan makinanın nakliye işlemlerinden alıcı sorumludur.
                  Alıcı, tüm taleplerini satıcı veya nakliye firmalarına iletebilir.
                  Satın alınan makinanın tüm ödeme işlemleri yapıldıktan sonra satıcı bilgileri alıcı ile paylaşılacaktır.
                </p>
                <p>
                  iyiMakina.com müşteri temsilcilerimiz, makinanın tüm ödemesi yapıldıktan sonra satıcı bilgilerini alıcı ile paylaşacaktır.
                </p>
              </div>
            </div>
            <SellYourMachineIn30Days />
            <FooterContactUs about="Nakliye ve Teslimat ile" />
          </div>
        </div>
      </div>
    </main>
  );
};

ShippingAndDelivery.propTypes = {
  t: PropTypes.func,
};

export const getServerSideProps = async () => {
  return {
    props: {
      blackHeader: true,
      headTitle: 'Nakliye ve Teslimat',
    },
  };
};

ShippingAndDelivery.Layout = Layout;

export default withTranslation('common')(ShippingAndDelivery);
